import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';

import styles from '../styles.js';
import cardStyles from './styles.js';

import LoadingAnimatedCard from './LoadingAnimatedCard';
import CardHOC from './Card/CardHOC.jsx';

export default class CardContainer extends PureComponent {
    static defaultProps = {
        cardSize: 'landscape'
    }

    static propTypes = {
        addImpressionEventToBatch: PropTypes.func.isRequired,
        cardId: PropTypes.number.isRequired,
        cardProportions: PropTypes.object.isRequired,
        containerClass: PropTypes.string.isRequired,
        contentLoading: PropTypes.bool.isRequired,
        initialContentLoaded: PropTypes.bool.isRequired,
        sliderDisabled: PropTypes.bool,
        unstable: PropTypes.bool.isRequired,
        width: PropTypes.number.isRequired
    }

    render() {
        return (
            <div
                className={css(styles[this.props.containerClass])}
                style={{
                    width: `${this.props.width}%`
                }}
            >
                <div
                    className={
                        this.props.sliderDisabled ?
                            css(cardStyles.cardContainer) :
                            css(cardStyles.cardContainer,
                                cardStyles.cardContainerDisabled_CarouselLg,
                                cardStyles.cardContainerDisabled_CarouselMd,
                                cardStyles.cardContainerDisabled_CarouselSm
                            )
                    }
                >
                    <div className={css(cardStyles.containerRelative)}>
                        {
                            (
                                this.props.initialContentLoaded &&
                                !this.props.contentLoading &&
                                !this.props.unstable
                            ) ?
                                <CardHOC
                                    addImpressionEventToBatch={this.props.addImpressionEventToBatch}
                                    cardId={this.props.cardId}
                                    cardPadding={this.props.cardProportions.padding}
                                /> :
                                <LoadingAnimatedCard
                                    cardPadding={this.props.cardProportions.padding}
                                />
                        }
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/CardContainer.jsx